import { Grid, useMediaQuery } from '@mui/material';
import React, { useContext, useState } from 'react';
import textStyles from "../../../../../../assets/styles/componentStyles/manychatStyles/instagramStepComponent.module.scss"
import styles from '../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import GlobalPopUp from "../../../../../utility/globalPopUp";
// import WebHookPopup from './customAPI/webHookPopup';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../../context/flowBuilderContext';
import { WorkflowContext, WorkflowContextPayload } from '../../../../../../context/workflowContext';
import WebhookConfigPopup from './webhookConfigPopup';
import { useStore } from '@xyflow/react';
import { useWebhookStore } from '../../../../../../store/webhookStore';
import { UserContext, UserContextPayload } from '../../../../../../context/userContext';
import { configuredWebhookData } from '../../../../../../models/axiosModel';
import { getConfiguredWebhook } from '../../../flowBuilderConstants';


function WebhookConfigCompact(props: any) {

    const { actionData, stepAction } = props;
    const [flagWebhookPopup, setFlagWebhookPopup] = useState<boolean>(false);
    const flagSmallScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 900px)');
    const { setFlagLoading } = useContext(UserContext) as UserContextPayload
    const { nodes, setTempNodesTemplate } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload
    const getWebhookOrganizationList = useWebhookStore((state) => state.getWebhookOrganizationList);
    const configuredWebhookData = useWebhookStore((state) => state.configuredWebhookData)
    async function getOrganizationConfiguredWebhooks() {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        await getWebhookOrganizationList();

        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    return (
        <Grid item>
            <Grid container direction={"column"} gap={"12px"}>
                <Grid item mt={2} className={textStyles.templatesContainer}>
                    <Grid container direction={"column"} gap={"8px"} flexWrap={"nowrap"}>
                        <Grid item className={`${styles.bodyFormHeadingStyle} ${globalStyles.primaryFontSize} ${globalStyles.primaryFontWeight}`}>
                            Await Webhook
                        </Grid>
                        <Grid item className={styles.contentBlockSubHeadingStyle} sx={{ '&:hover': { backgroundColor: "rgba(0,0,0,0.02)" }, padding: "2px 4px" }}>
                            <Grid container gap={1} justifyContent={"space-between"} flexWrap={"nowrap"} alignItems={"center"}>
                                <Grid item sx={{ wordBreak: "break-word" }}>
                                    {actionData?.webhook_organization_id ? 
                                        <Grid container direction={"column"} gap={1}>
                                            <a href={`${window.location.origin}/webhook`} target='blank'>
                                                {getConfiguredWebhook(configuredWebhookData, actionData.webhook_organization_id) ? getConfiguredWebhook(configuredWebhookData, actionData.webhook_organization_id)?.webhook_external?.webhook_external_company_name : ""}
                                            </a>
                                            <Grid item className={styles.webhookPathTypography}>
                                                {getConfiguredWebhook(configuredWebhookData, actionData.webhook_organization_id) ? getConfiguredWebhook(configuredWebhookData, actionData.webhook_organization_id)?.webhook_organization_full_path : ""}
                                            </Grid>
                                        </Grid>
                                        :
                                        "Please select a Webhook"
                                    }
                                </Grid>
                                <Grid item>
                                    <ModeEditIcon sx={{ display: "flex", height: "16px", width: "16px", cursor: "pointer" }} onClick={() => { getOrganizationConfiguredWebhooks(); setFlagWebhookPopup(true); setTempNodesTemplate(nodes) }} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            {flagWebhookPopup &&
                <GlobalPopUp
                    open={flagWebhookPopup}
                    onClose={() => {
                        setFlagWebhookPopup(false);
                    }}
                    flagBackdrop
                    paperMinWidth={flagSmallScreen ? "280px" : "75%"}
                    paperMaxwidth={flagSmallScreen ? "580px" : "75%"}
                    flagShowCloseIcon={true}
                    height={"100%"}
                    titlePadding='0'
                    handleClose={() => {
                        setFlagWebhookPopup(false)
                    }}
                >
                    <WebhookConfigPopup actionData={actionData} stepAction={stepAction} setFlagWebhookPopup={setFlagWebhookPopup} getOrganizationConfiguredWebhooks={getOrganizationConfiguredWebhooks} />
                </GlobalPopUp>
            }
        </Grid>
    )
}

export default WebhookConfigCompact